import * as types from './constants';

// Check Reimbursement Balance
export const checkReimbursementBalanceRequest = data => (
  { type: types.CHECK_REIMBURSEMENT_BALANCE_REQUEST, payload: data }
);

export const checkReimbursementBalanceDone = data => (
  { type: types.CHECK_REIMBURSEMENT_BALANCE_DONE, payload: data }
);

export const checkReimbursementBalanceFailed = errors => (
  { type: types.CHECK_REIMBURSEMENT_BALANCE_FAILED, payload: errors }
);

export const checkReimbursementBalanceReset = () => (
  { type: types.CHECK_REIMBURSEMENT_BALANCE_RESET }
);